import getOr from "lodash/fp/getOr";

import { ROOT_GLOBAL } from "../global/root";
import { LocalStorage } from "./LocalStorage";

export class Auth {
  constructor(id, full_name, refresh_token, auth_token, email) {
    this.id = id;
    this.fullName = full_name;
    this.refreshToken = refresh_token;
    this.authToken = auth_token;
    this.email = email;
  }
  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Auth(
        getOr(undefined, "data.id")(input),
        getOr(undefined, "data.full_name")(input),
        getOr(undefined, "refresh_token")(input),
        getOr(undefined, "auth_token")(input),
        getOr(undefined, "data.email")(input),
      )
    }
    return new Auth();
  }
  static fromApiArray(input) {
    if (Array.isArray(input)) {
      return input.map(item => Auth.fromApiObject(item));
    }
    if (typeof (input) === "object") {
      return [Auth.fromApiObject(input)];
    }
    return [];
  }

  isVaildAuth() {
    return !!this.authToken && !!(this.id + '')
  }

  saveLoginInfo(useOldRefresh = false) {
    LocalStorage.setLoginInfo(this.authToken, this.fullName, this.id, useOldRefresh ? LocalStorage.getRefreshToken() : this.refreshToken, this.email);
  }

  setNewToken() {
    LocalStorage.setUserToken(this.authToken);
  }

  static callBackLogin(cb) {
    if (cb === undefined) {
      cb = window.location.href;
    }
    return `${ROOT_GLOBAL.LOGIN}&cb=${encodeURIComponent(cb)}`
  }

  static callBackSignUp(cb) {
    if (cb === undefined) {
      cb = window.location.href;
    }
    return `${ROOT_GLOBAL.SIGN_UP}&cb=${encodeURIComponent(cb)}`
  }

  static isSocialProvider(provider) {
    return [Auth.TYPE.GOOGLE, Auth.TYPE.FACEBOOK, Auth.TYPE.TWITTER, Auth.TYPE.APPLE].includes(provider);
  }

  static isDefaultProvider(provider) {
    return [Auth.TYPE.EMAIL, Auth.TYPE.PHONE].includes(provider);
  }

  static TYPE = {
    PHONE: "phone",
    FIREBASE_PHONE: "firebase_phone",
    EMAIL: "email",
    GOOGLE: "google",
    FACEBOOK: "facebook",
    TWITTER: "twitter",
    APPLE: "apple",
  }

  static LIST_AUTH = [
    {
      provider: this.TYPE.PHONE,
      label: "login_withPhone",
      icon: require("../assets/images/login/login-phone.svg"),
      type: "input",
    },
    {
      provider: this.TYPE.EMAIL,
      label: "login_withEmail",
      icon: require("../assets/images/login/login-email.svg"),
      type: "input",
      hide: true,
    },
    {
      provider: this.TYPE.GOOGLE,
      label: "login_withGoogle",
      icon: require("../assets/images/login/login-google.svg"),
      type: "social",
      hide: true,
    },
    {
      provider: this.TYPE.FACEBOOK,
      label: "login_withFacebook",
      icon: require("../assets/images/login/login-facebook.svg"),
      type: "social",
      hide: true,
    },
    {
      provider: this.TYPE.APPLE,
      label: "login_withApple",
      icon: require("../assets/images/login/login-apple.svg"),
      type: "social",
      hide: true,
    }
  ]

  static LIST_AUTH_DEFAULT = [
    {
      code: Auth.TYPE.PHONE,
    }
  ]
}